import { ISectionsLinks, IStaticPage, IStaticPageLink } from 'core/model/interfaces/static-page.interface';
import { ISectionsLinksDto, IStaticPageDetailDto, IStaticPageLinkDto } from './static-page.dto';

export const staticPageMapper = {
  toSectionsLinks: (response: ISectionsLinksDto): ISectionsLinks => ({
    sections: response.sections.map(section => ({
      title: section.title,
      pages: section.pages.map(page => staticPageMapper.toStaticPagesLink(page)),
    })),
  }),

  toStaticPagesLink: (page: IStaticPageLinkDto): IStaticPageLink => ({
    id: page.id,
    title: page.title,
    url: page.pageUri,
    pageTypeId: page.pageType.id,
    iconUrl: page.iconUrl,
    redirectUrl: page.redirectUrl || '',
  }),

  toStaticPageDetail: (response: IStaticPageDetailDto): IStaticPage => ({
    id: response.id,
    title: response.title,
    textContent: response.textContent,
    imageUrl: response.imageUrl,
    mobileImageUrl: response.mobileImageUrl,
    pageTypeId: response.pageType?.id,
  }),
};
